import { useViewContext } from 'providers/ViewContextProvider';
import React, { useState, createContext, useContext } from 'react';
import { node } from 'prop-types';

const NavInfoContext = createContext(null);
export const useNavInfoContext = () => useContext(NavInfoContext);

function NavInfoProvider({ children }) {
  const [isSearchFieldFocused, setIsSearchFieldFocused] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchFieldExpandInMobile, setIsSearchFieldExpandInMobile] =
    useState(false);
  const [scrollDownRange, setScrollDownRange] = useState(0);

  return (
    <NavInfoContext.Provider
      value={{
        isSearchFieldFocused,
        setIsSearchFieldFocused,
        isMobileMenuOpen,
        setIsMobileMenuOpen,
        isSearchFieldExpandInMobile,
        setIsSearchFieldExpandInMobile,
        scrollDownRange,
        setScrollDownRange,
      }}
    >
      {children}
    </NavInfoContext.Provider>
  );
}

NavInfoProvider.propTypes = {
  children: node,
};

export default NavInfoProvider;
